export class ClientEspNdcImportFilters {
  selectedClientIds = [];
}
